import { Role } from "@/@types/app/Role";
import { ModuleEnum } from "@/utils/enums/ModuleEnum";
import {
	CityEsusRoleEnum,
	CitySIntegradaRoleEnum,
	StateEsusRoleEnum,
} from "@/utils/enums/RoleEnum";
import { managerHasPermission } from "./managerHasPermission";

export function filteredRoleByModule(
	isAdmin: boolean,
	roles: Role[],
	permissions: string[],
	module?: ModuleEnum
) {
	const hasPermissionStateAndCity =
		(managerHasPermission(permissions, "State", module) &&
			managerHasPermission(permissions, "Municipality", module)) ||
		isAdmin;
	switch (module) {
		case ModuleEnum.ESUS_APS:
			if (hasPermissionStateAndCity) {
				return roles.filter((role) =>
					[...Object.values(StateEsusRoleEnum), ...Object.values(CityEsusRoleEnum)].find(
						(RoleObjectEnum) => String(role.id) === RoleObjectEnum
					)
				);
			}
			if (managerHasPermission(permissions, "Municipality", module)) {
				return roles.filter((role) =>
					Object.values(CityEsusRoleEnum).find(
						(roleObjectEnum) => String(role.id) === roleObjectEnum
					)
				);
			}
			return [];
		case ModuleEnum.SINTEGRADA:
			return roles.filter((role) =>
				Object.values(CitySIntegradaRoleEnum).find(
					(RoleObjectEnum) => String(role.id) === RoleObjectEnum
				)
			);

		default:
			return roles;
	}
}
